import { Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDezSrEvdListaEvidencijaHeader: React.FC<{
  naziv: string;
  vrsta: string;
  primjena: string;
  upustvoZaUpotrebu: string;
  slika: string;
  tackaEvidencije: string;
}> = ({
  naziv,
  vrsta,
  primjena,
  upustvoZaUpotrebu,
  slika,
  tackaEvidencije,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{vrsta}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{primjena}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{upustvoZaUpotrebu}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{slika}</Text>
    </View>
  </View>
);

export const TableRowDezSrEvdListaEvidencija: React.FC<{
  naziv: string;
  vrsta: string;
  primjena: string;
  upustvoZaUpotrebu: string;
  slika?: string;
  slikaRes: string;
  tackaEvidencije: string;
}> = ({
  naziv,
  primjena,
  upustvoZaUpotrebu,
  slika,
  vrsta,
  tackaEvidencije,
  slikaRes,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaEvidencije}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{vrsta}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primjena}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{upustvoZaUpotrebu}</Text>
    </View>
    <View style={styles.tableCol}>
      {slika && (
        <Link src={slika} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);
